import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { serializeQueryParams } from 'src/app/service-helper';
import { environment } from 'src/environments/environment';
import {
  CreateCategoryRequest,
  DuplicateCategoryRequest,
  GetCategoryRequest,
  GetCategoryResponseItem,
  GetCategoryResponse,
  UpdateCategoryRequest,
} from './models/category.service.model';

@Injectable({
  providedIn: 'root',
})
export class CategoryService {
  private readonly baseURL: string = `${environment.apiUrl}/api/Category`;

  constructor(private readonly http: HttpClient) {}

  create(request: CreateCategoryRequest) {
    return this.http.post(this.baseURL, request);
  }

  duplicate(id: string, request: DuplicateCategoryRequest) {
    return this.http.post(this.baseURL + '/duplicate/' + id, request);
  }

  get(filter: GetCategoryRequest): Observable<GetCategoryResponse> {
    const params = serializeQueryParams(filter);
    return this.http.get<GetCategoryResponse>(this.baseURL, { params });
  }

  getById(id: string): Observable<GetCategoryResponseItem> {
    return this.http.get<GetCategoryResponseItem>(this.baseURL + '/' + id);
  }

  update(id: string, request: UpdateCategoryRequest) {
    return this.http.put(this.baseURL + '/' + id, request);
  }

  delete(id: string) {
    return this.http.delete(this.baseURL + '/' + id);
  }
}
